/* eslint-disable react/no-danger */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AWS from 'aws-sdk';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Cloudy from '../../../icons/weather.svg';
import styles from './weathers.module.scss';
import { saveWeatherData } from '../../AirfieldsConditions/components/redux/actions';
import Spinner from '../../../components/spinner';
import Humidity from '../../../icons/humidity.png';
import Wind from '../../../icons/wind.png';
import visibility from '../../../icons/visibility.png';
import Pressure from '../../../icons/pressu.png';


const Weather = ({ profile, actionSaveWeather, weather }) => {
  const [loading, setLoading] = useState(false);
  const [noWeatherData, setNoWeatherData] = useState(false);
  const [timeDiff, setTimeDiff] = useState(0);
  const getData = () => {
    const today = moment().utc();
    const year = today.year();
    const month = today.month();
    const date = today.date();
    const hour = today.hour();
    const docClient = new AWS.DynamoDB.DocumentClient();
    const params = {
      TableName: `${process.env.REACT_APP_MAIN_PREFIX}weather`,
      Key: { id: `${profile.portal_airport.code.toUpperCase()}_${year}_${month+1}_${date}_${hour-timeDiff}` }
    };
    docClient.get(params).promise().then((data) => {
      if (!data.Item) {
        const diff = timeDiff + 1;
        setLoading(false);
        setTimeDiff(diff);
        if (timeDiff === 4) {
          setNoWeatherData(true);
        }
      } else {
        setTimeDiff(5);
        actionSaveWeather(data.Item.metar);
        setLoading(false);
        setNoWeatherData(false);
      }
    }).catch((err) => {
      setLoading(false);
      console.log(err);
    });
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getFormattedTime());
      setCurrentDay(getFormattedDay());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    if (!weather.summary && timeDiff !== 5) {
      setLoading(true);
      getData();
    }
  }, [weather.summary, timeDiff]);

  const Metrics = profile?.portal_airport?.airport_settings?.metrics;
  const dispTemp = (temp) => {
    const indexValue = temp.indexOf('(');
    if (indexValue !== -1) {
      if (typeof Metrics === 'object') {
        if (Array.isArray(Metrics)) {
          if (Metrics[0]?.metric === 'USCS') {
            return temp.slice(indexValue+1, temp?.length-1);
          }
            return temp.slice(0, indexValue-1);
        }
        if (Metrics?.metric === 'USCS') {
          return temp.slice(indexValue+1, temp?.length-1);
        }
          return temp.slice(0, indexValue-1);
      }
    }
    return temp.slice(0, 6);
  };
  const getFormattedTime = () => {
    const currentDayTime = new Date();
    const timeData = { hour: 'numeric', minute: 'numeric', hour12: true };
    return currentDayTime.toLocaleTimeString(undefined, timeData).replace(/^0/, '12');
  };
  const getFormattedDay = () => {
    const currentDayTime = new Date();
    return moment.weekdays(currentDayTime.getDay());
  };
  const [currentTime, setCurrentTime] = useState(getFormattedTime());
  const [currentDay, setCurrentDay] = useState(getFormattedDay());

  return (
    <div className={`${styles.weather} ${styles.weatherOverFlow}`}>
      <div className={styles.spinner}>
        <Spinner large active={loading} />
      </div>
      <div className={styles.header}>
        <span className={styles.fontcolor}>{currentDay}</span>
        <span className={styles.fontcolor}>{currentTime}</span>
      </div>
        <div className={styles.top}>
          <img src={Cloudy} alt="" />
          <br />
          <h3 style={{ color: 'white' }}>{weather && weather.temperature && dispTemp(weather.temperature)}</h3>
        </div>
        <div className={styles.colom}>
          <h5 style={{ color: 'white' }}>{weather && weather.summary && weather.summary.toUpperCase()}</h5>
        </div>
      {!noWeatherData
        ? (
          <div divided="vertically" className={styles.content}>
            <div style={{ justifyContent: 'space-evenly', padding: '5px 10px', display: 'flex' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                <div className={styles.detail_item}>
                  <div className={styles.iconouter}>
                    <img src={Humidity} alt="" style={{ height: '30px' }} />
                  </div>
                  <div className={styles.colom}>
                    <span className={`${styles.fontcolor} ${styles.head}`}>
                    <FormattedMessage id="weather.humidity" defaultMessage="Humidity" />
                    </span>
                    <span className={styles.fontcolor} dangerouslySetInnerHTML={{ __html: weather && weather.humidity }} />
                  </div>
                </div>
                <div className={styles.detail_item}>
                  <div className={styles.iconouter}>
                    <img src={Wind} alt="" style={{ height: '25px' }} />
                  </div>
                  <div className={styles.colom}>
                    <span className={`${styles.fontcolor} ${styles.head}`}>
                    <FormattedMessage id="weather.wind" defaultMessage="Wind" />
                    </span>
                    <span className={styles.fontcolor} dangerouslySetInnerHTML={{ __html: weather && weather.wind }} />
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                <div className={styles.detail_item}>
                  <div className={styles.iconouter}>
                    <img src={Pressure} alt="" style={{ height: '30px' }} />
                  </div>
                  <div className={styles.colom}>
                    <span className={`${styles.fontcolor} ${styles.head}`}>
                    <FormattedMessage id="weather.pressure" defaultMessage="Pressure" />
                    </span>
                    <span className={styles.fontcolor} dangerouslySetInnerHTML={{ __html: weather && weather.pressure }} />
                  </div>
                </div>
                <div className={styles.detail_item}>
                  <div className={styles.iconouter}>
                    <img src={visibility} alt="" style={{ height: '21px' }} />
                  </div>
                  <div className={styles.colom}>
                    <span className={`${styles.fontcolor} ${styles.head}`}>
                    <FormattedMessage id="weather.visibility" defaultMessage="Visibility" />
                    </span>
                    <span className={styles.fontcolor} dangerouslySetInnerHTML={{ __html: weather && weather.visibility }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          )
          : <div className={styles.noWeatherInfo}> Currently, there is no weather information for the airport</div>}
    </div>
  );
};

const mapStateToProps = state => ({
  weather: state.airfields.weather,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionSaveWeather: (data) => {
    dispatch(saveWeatherData(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Weather);
